import { render, staticRenderFns } from "./PdfEditorLocal.vue?vue&type=template&id=16e4fd0c&"
import script from "./PdfEditorLocal.vue?vue&type=script&lang=js&"
export * from "./PdfEditorLocal.vue?vue&type=script&lang=js&"
import style0 from "./PdfEditorLocal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PdfEditorLocal.vue?vue&type=style&index=1&lang=scss&"
import style2 from "../../assets/tailwind.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports